import React from 'react'
import combineClass from '@helpers/combineClass'

const SectionContent = ({ children, className = '' }) => (
  <div className={combineClass('content', className)}>{children}</div>
)

export default SectionContent
